import { render } from "./GalleryCheckButton.vue?vue&type=template&id=c63dd1a6&scoped=true"
import script from "./GalleryCheckButton.vue?vue&type=script&lang=js"
export * from "./GalleryCheckButton.vue?vue&type=script&lang=js"

import "./GalleryCheckButton.vue?vue&type=style&index=0&id=c63dd1a6&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63dd1a6"]])

export default __exports__